import { HiExclamationCircle } from "react-icons/hi";
import { JSX } from "react";
import { showToast } from "@/pages/OrderByPOS/Component/Message/ShowToast";
import socket from "@/utils/socket";

export const handleSocketEventCustomer = (
    event: string,
    message: string,
    sound: HTMLAudioElement,
    icon: JSX.Element = <HiExclamationCircle size={24} style={{ color: "#527FDF" }} />,
    options: { reverse: boolean } = { reverse: false }
) => {
    const listener = (data: any) => {
        if (!localStorage.getItem("token")) return;
        if (data?.success && data?.data) {
            sound?.play?.()?.catch?.(() => {});
            const items = Array.isArray(data.data) ? data.data : [data.data];
            items.forEach((item: any) => {
                const tableName = item?.tableName || item?.name || data.data?.tableName || "";
                showToast(message, tableName, icon, options);
            });
        }
    };

    socket.on(event, listener);

    return () => {
        socket.off(event, listener);
    };
};